import { EquipmentItem } from 'types';

export const INTRO_CAROUSEL_DATA = [
    {
        id: 0,
        image: '/assets/images/treasure.png',
        text: 'Оплачиваемый опыт',
    },
    {
        id: 1,
        image: '/assets/images/anchor.png',
        text: 'Стабильная компания',
    },
    {
        id: 2,
        image: '/assets/images/coins.png',
        text: 'Возможность развиваться',
    },
    {
        id: 3,
        image: '/assets/images/bell.png',
        text: 'Признание <br />от команды',
    },
    {
        id: 4,
        image: '/assets/images/compas.png',
        text: 'Внутреннее обучение',
    },
    {
        id: 5,
        image: '/assets/images/shturval.png',
        text: 'Реальные задачи',
    },
    {
        id: 6,
        image: '/assets/images/bear.png',
        text: 'Карьерный наставник',
    },
];

export const EQUIPMENT_DATA: EquipmentItem[] = [
    {
        id: 'conditions',
        title: 'Условия работы\nи офис',
        icon: '/assets/images/equipment/planet.png',
        items: [
            'Московский офис работает 24/7',
            'Формат работы: гибрид, офис',
            'Комфортный и зеленый офис',
            'Собственная территория и пляж',
            'Бесплатные спортзалы и сауна в офисе',
            'Магазин, рестораны, банкоматы на территории офиса',
            'Парковка: подземная авто, самокаты, велосипеды',
            'Постаматы с мерчем и необходимыми мелочами',
            'Вендинговые аппараты и аппараты с кофе',
            'Музей «Лаборатории Касперского» и Виртуальная Лаборатория',
            'Радио Kaspersky RadioLAB',
        ],
    },
    {
        id: 'corporate_life',
        title: 'Корпоративная\nжизнь',
        icon: '/assets/images/equipment/handshake.png',
        items: [
            'Тимбилдинги и корпоративные мероприятия',
            'Performance Champions Program',
            'AMA-сессии с топ-менеджментом',
            'Kick-off встречи',
            'Ежегодный опрос удовлетворенности YourVoice',
            'Благотворительные проекты',
            'Поддержка корпоративных спортивных команд',
            'Клубы по интересам',
            'Внезапные завтраки для нетворкинга',
            'Подарки на праздники',
            'Зоны для игр и отдыха в офисе',
        ],
    },
    {
        id: 'health',
        title: 'Здоровье',
        icon: '/assets/images/equipment/health.png',
        items: ['Врач и массажист в офисе', 'Психолог в офисе', 'Полис ОМС с доставкой в офис'],
    },
    {
        id: 'bonuses',
        title: 'Дополнительные\nбонусы',
        icon: '/assets/images/equipment/star.png',
        items: ['Мерч', 'Скидки от партнеров', 'Лицензии на продукты компании'],
    },
    {
        id: 'reward',
        title: 'Вознаграждение',
        icon: '/assets/images/equipment/diamond.png',
        items: ['Конкурентная зарплата', 'Доплата на питание', 'Авторские выплаты', 'Программа рекомендаций'],
    },
    {
        id: 'education',
        title: 'Обучение и развитие',
        icon: '/assets/images/equipment/books.png',
        items: [
            'Воркшопы от Kaspersky Academy',
            'Онлайн-курсы, бизнес-симуляции и игры по продуктам компании',
            'Лекции для сотрудников от внешних экспертов',
        ],
    },
];
